import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { startPurchaseEvents, stopPurchaseEvents } from '../utils/purchaseEventsHub';

const PurchaseEventsProvider = () => {
  const location = useLocation();
  const isClientPortal = location.pathname.startsWith('/client-portal');
  const match = location.pathname.match(/\/branches\/(\d+)/);
  const branchId = isClientPortal ? '' : match ? match[1] : localStorage.getItem('selectedBranchId');

  useEffect(() => {
    startPurchaseEvents(branchId);
    return () => {
      stopPurchaseEvents();
    };
  }, [branchId]);

  return null;
};

export default PurchaseEventsProvider;
